import * as styles from "./SectionHighlightedTextBlock.module.scss";

import React from "react";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionHighlightedTextBlockProps
	extends DogsTrust.WrappedSectionProps {
	htmlText?: string;
}

export const getSectionHighlightedTextBlockProps = ({
	field_section_short_description,
}: Queries.SectionDataFragment): SectionHighlightedTextBlockProps => ({
	htmlText: field_section_short_description?.value,
});
export const SectionHighlightedTextBlock: React.FC<
	SectionHighlightedTextBlockProps
> = ({ htmlText }) => {
	return (
		<WrappedSection sectionName="SectionHighlightedTextBlock">
			<div className={styles.highlightedtextinner}>
				<div
					className={styles.textarea}
					// biome-ignore lint/security/noDangerouslySetInnerHtml: Safe source
					dangerouslySetInnerHTML={{
						__html: htmlText,
					}}
				/>
			</div>
		</WrappedSection>
	);
};

export default SectionHighlightedTextBlock;
